/* eslint-disable eqeqeq */
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  fixed_tax_id: '',
  quantity: '',
};

function FixTaxUpdateModal({
  handleUpdateFixTaxData, getBusinessFixTaxInfo, businessFixTaxInfo,
  businessId, id, fixTaxList, updateFixTax,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);

  const updateData = () => {
    getBusinessFixTaxInfo(businessId, id);
    setFormData({
      fixed_tax_id: '',
      quantity: '',
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateFixTax(businessId, id, formData, () => {
      setModal({ isOpen: false });
      handleUpdateFixTaxData();
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelected = key => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(businessId && id)) {
      updateData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(businessId && id)) {
      updateData();
    }
  }, [businessId, id]);

  useEffect(() => {
    if (!_.isEmpty(businessId && id && businessFixTaxInfo)) {
      setFormData({
        fixed_tax_id: _.get(businessFixTaxInfo, 'attributes.fixed_tax_id') || '',
        quantity: _.get(businessFixTaxInfo, 'attributes.quantity') || '',
      });
    }
  }, [businessFixTaxInfo]);

  const fixTaxOptions = fixTaxList.map(x => ({ label: _.get(x, 'attributes.label'), value: x.id, id: x.id }));
  return (
    <Modal.Body>
      <form className="container-fluid" onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6 form-group">
            <label className="form-label d-flex align-items-center"><span className="mr-auto mr-0 text-muted">Name</span></label>
            <Select
              value={fixTaxOptions.filter(item => _.get(formData, 'fixed_tax_id') == _.get(item, 'id')) || ''}
              onChange={handleSelected('fixed_tax_id')}
              options={fixTaxOptions}
              placeholder="Select Fix Tax..."
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label d-flex align-items-center"><span className="mr-auto mr-0 text-muted">Quantity</span></label>
            <input
              id="quantity"
              name="quantity"
              type="number"
              value={formData.quantity}
              onChange={handleOnChange}
              placeholder="Quantity"
              className="form-control"
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
              >
                <span className="font-weight-bold">
                  Submit
                </span>
              </button>
              <button
                type="button"
                onClick={closeModal}
                className="mt-3 btn btn-dark "
              >
                <span className="font-weight-bold">
                  Cancel
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

FixTaxUpdateModal.propTypes = {
  handleUpdateFixTaxData: PropTypes.instanceOf(Function).isRequired,
  getBusinessFixTaxInfo: PropTypes.instanceOf(Function).isRequired,
  businessFixTaxInfo: PropTypes.instanceOf(Object).isRequired,

  updateFixTax: PropTypes.instanceOf(Function).isRequired,
  fixTaxList: PropTypes.instanceOf(Array).isRequired,
  businessId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessFixTaxInfo: _.get(api, `${c.GET_FIX_TAX_INFO}.item`) || {},
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(FixTaxUpdateModal);
